module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAADCAYAAABF//VLAAAAR0lEQVQImWOcM2fOfwYiAQuyOj4+PgZDQ0MGSUlJMP/58+cM586dY/j8+TOYz4Ss2NHRkUFWVpaBhYUFjEFsJycniCQDAwMAsGcOKt4QKVkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coupon-disabled.png
// module id = hjmb
// module chunks = 16